// extracted by mini-css-extract-plugin
export default {"container":"AboutUs_container__vVBNt","aboutContainer":"AboutUs_aboutContainer__kNVJH","collapseContainer":"AboutUs_collapseContainer__LX1Sn","collapse":"AboutUs_collapse__ZwCV7"};